import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAttrs } from "vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'AppSearchField',
  props: /*@__PURE__*/_mergeModels({
    placeholder: { default: "Search..." },
    hideDetails: { type: [Boolean, String], default: true }
  }, {
    "modelValue": { default: "" },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel<string>(__props, "modelValue");



const attrs = useAttrs();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppTextField, _mergeProps({
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
  }, _unref(attrs), {
    "prepend-inner-icon": "mdi-magnify",
    "hide-details": __props.hideDetails,
    placeholder: __props.placeholder
  }), null, 16, ["modelValue", "hide-details", "placeholder"]))
}
}

})